import { Stack } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { IDocFileInfo } from '../../../redux/project/documents/sliceProjectDocuments';
import { headingFontBold } from '../../../Theme';
import AppTooltip from '../AppTooltip/AppTooltip';
import FileIcon from '../Icons/FileIcon';

/**
 * Component that shows an overview of the files that are associated with a document in the DataGrid.
 */
export default (props: { fileInfo: IDocFileInfo }) => {
    /** Configure component translation. */
    const { t } = useTranslation('translations', { keyPrefix: 'docTable' });

    /** Deconstruct props. */
    const { fileInfo } = props;

    /** No file data present for this document - stop here. */
    if (!fileInfo || fileInfo.Count === 0) {
        return <></>;
    }

    /** File data is present, so need to subtract 1 from the total (because the total includes the main file). */
    const count = fileInfo.Count - 1;

    /** Configure extra tooltip content if the document has more than 1 file attached. */
    const extraTooltip = count > 0 && t(count > 1 ? 'tooltipFiles' : 'tooltipFile', { count });

    return (
        <AppTooltip
            title={
                <>
                    {fileInfo.FileName}
                    <br />
                    {extraTooltip}
                </>
            }
            placement='top-start'
        >
            <Stack
                direction='row'
                sx={{
                    alignItems: 'center',
                    minWidth: 60,
                }}
            >
                <Stack
                    sx={{
                        flexGrow: 0,
                        width: 30,
                    }}
                >
                    <FileIcon fileName={fileInfo.FileName} />
                </Stack>

                <Stack sx={{ ...headingFontBold, fontSize: 12, lineHeight: 'initial' }}>
                    {count > 0 && `+${count}`}
                </Stack>
            </Stack>
        </AppTooltip>
    );
};
